import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import { useRtoaster } from "../../../hooks/useRtoaster";
import CommonValidation from "../../../common/commonValidation";
import { apiKeyCheck, getDouhanList, getDouhanSelectList, registerCompanion, versionGetApi } from "../../../const";
import messageConst from "../../../const/messageConst";
import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { Label } from '../../atoms/label';
import { BreadCrumb } from '../../molecules/breadCrumb';
import { ErrorMassage } from "../../molecules/errorMassage";
import { LabelInputForm } from "../../molecules/labelInputForm";
import { RadioButtonForm } from '../../molecules/radioButtonForm';
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import './../../../resources_membership_hotel/css/hotel/accompany.css';
import { LabelComboBoxForm } from "../../molecules/labelComboBoxForm";
import { InputText } from "../../atoms/inputText";
import { CheckboxListBoxGold } from "../../molecules/checkboxListBoxGold";

const MembershipInputAccompanyContainer = (props) => {
    const {
        state,
        login,
        checkIn,
        checkOut,
        membershipReserveComf,
        setAccompanyPath,
        inputAccompanyInfo,
        setInputAccompanyInfo,
        setDisplayType,
        resvKaiinken,
        prevScreenInfo
    } = props;

    const loginType = login.loginType;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [douhanSelectList, setDouhanSelectList] = useState([]);

    const history = useHistory();
    const store = useStore();

    const [linkList, setLinkList] = useState([]);

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false });
    const [flgList, setFlgList] = useState([]);

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        if (membershipReserveComf.pageKbn === "membershipResvComp") {
            // 予約完了画面
            if (loginType === "MEMBER") {
                setLinkList([
                    { path: "/reserve/top", label: "HOME" },
                    { path: "/reserve/hotel/search", label: "ホテル予約" },
                    { path: "/reserve/hotel/searchResult", label: "検索結果" },
                    { path: "/reserve/hotel/reserveComplete", label: "予約完了" }
                ]);
            } else if (loginType === "CRAWL") {
                setLinkList([
                    { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                    { path: "/reserve/hotel/searchResult", label: "検索結果" },
                    { path: "/reserve/hotel/reserveComplete", label: "予約完了" }
                ]);
            }
        } else if (membershipReserveComf.pageKbn === "membershipResvComf") {
            // 予約内容確認画面
            if (loginType === "MEMBER") {
                setLinkList([
                    { path: "/reserve/top", label: "HOME" },
                    { path: "/reserve/hotel/search", label: "ホテル予約" },
                    { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" }
                ]);
            } else if (loginType === "CRAWL") {
                setLinkList([
                    { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                    { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" }
                ]);
            }
        }
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }

        // 同行者情報取得
        if (prevScreenInfo && prevScreenInfo.currentPath.indexOf("hotel/confirmAccompany") == -1 ) {
            common.doPost(getDouhanList, { yoyakuNo: membershipReserveComf.yoyakuNo, riyoDat: membershipReserveComf.checkInDate }, afterGetDouhanList);
        }
        // setInputAccompanyInfo([
        //     {
        //         seq: 0, roomTypeCd: "1", rmTypeNam: "テスト１", ninzuMale: 1, ninzuFemale: 1, ninzuChild: 0, ninzuYoji: 1, ninzuBaby: 1, doukouList: [
        //             { riyoNo: "1", typeName: "男性", riyoNamkn: "ダイヒョウ", riyoNamkj: "ダイヒョウ" },
        //             { riyoNo: "2", typeName: "女性", riyoNamkn: "", riyoNamkj: "" },
        //             { riyoNo: "4", typeName: "幼児", riyoNamkn: "", riyoNamkj: "" },
        //             { riyoNo: "5", typeName: "3歳未満", riyoNamkn: "", riyoNamkj: "" }
        //         ]
        //     },
        //     {
        //         seq: 1, roomTypeCd: "2", rmTypeNam: "テスト２", ninzuMale: 0, ninzuFemale: 1, ninzuChild: 1, ninzuYoji: 0, ninzuBaby: 0, doukouList: [
        //             { riyoNo: "8", typeName: "女性", riyoNamkn: "", riyoNamkj: "" },
        //             { riyoNo: "9", typeName: "子供", riyoNamkn: "", riyoNamkj: "" }
        //         ]
        //     },
        // ])
        if (membershipReserveComf.pageKbn === "membershipResvComp") {
            setAccompanyPath("/reserve/hotel/reserveComplete");
        } else if (membershipReserveComf.pageKbn === "membershipResvComf") {
            setAccompanyPath("/reserve/hotel/hotelBookingConfirmDetail");
        }

        // コンボボックスの情報を取得
        common.doPost(getDouhanSelectList, { pointKaiinId: login.memberCode }, afterGetDouhanSelectList);
    }, []);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    /**
     * 同行者情報取得後処理
     * @param {any} res APIレスポンス
     */
    const afterGetDouhanList = (res) => {
        if (res.data.resultCode != 0) {
            // TODO: 失敗時処理未実装
            return;
        }
        let roomWariList = res.data.roomWariList;
        let isRepresent = false;
        let representInfo = {};
        roomWariList.forEach(room => {
            // 合計人数
            const totalNinzu = room.ninzuMale + room.ninzuFemale + room.ninzuChild + room.ninzuYoji + room.ninzuBaby;
            let newDoukouList = [];
            if (room.doukouList.length) {
                // 配列に要素がある場合
                newDoukouList = room.doukouList;
                // 代表者情報の存在チェック
                if (!isRepresent) {
                    representInfo = newDoukouList.find(value => value.riyoNo == 1);
                    isRepresent = representInfo ? true : false;
                }
                // 配列の要素数が不足していれば初期値で補填
                if (room.doukouList.length < totalNinzu) {
                    for (let index = room.doukouList.length; index < totalNinzu; index++) {
                        newDoukouList.push({ riyoNo: 0, roomSeq: index + 1, customerSeq: "", riyoNamkn: "", riyoNamkj: "", isRepresent: false, saveFlg: false });
                    }
                }
            } else {
                // 配列でない場合は合計人数分の初期値を設定
                for (let index = 0; index < totalNinzu; index++) {
                    newDoukouList.push({ riyoNo: 0, roomSeq: index + 1, customerSeq: "", riyoNamkn: "", riyoNamkj: "", isRepresent: false, saveFlg: false });
                }
            }
            room.doukouList = newDoukouList;
        });
        // riyoNoの割り振り
        let riyoNo = isRepresent ? 1 : 0;
        roomWariList.forEach(room => {
            let roomSeq = 0;
            room.doukouList.forEach(doukou => {
                if (doukou.riyoNo != 1) {
                    doukou.riyoNo = ++riyoNo;
                    doukou.roomSeq = ++roomSeq;
                }
                if (doukou.riyoNo == 1) {
                    if (isRepresent) {
                        roomSeq++;
                    }
                    doukou.riyoNamkn = membershipReserveComf.daihyouNameKana;
                    doukou.riyoNamkj = membershipReserveComf.daihyouName;
                    doukou.isRepresent = isRepresent;
                    doukou.saveFlg = false;
                }
            });
        });
        setInputAccompanyInfo(roomWariList);
    }

    /**
     * 同行者情報取得後処理 ※コンボボックスに値を設定
     * @param {any} res APIレスポンス
     */
    const afterGetDouhanSelectList = (res) => {
        const data = res.data;
        setDouhanSelectList(data.doukouList ?? []);
    }

    /**
     * 指定された同行者を代表者として設定し、全同行者にriyoNoを振り直す。
     * @param {any} roomIndex
     */
    const handleRepresentFlg = (roomIndex) => {
        let riyoNo = 1;
        inputAccompanyInfo.map((room, roomIndex2) => {
            room.doukouList.map((doukou, doukouIndex) => {
                const docIdKn = "riyoNamkn_" + roomIndex2 + "_" + doukouIndex;
                const docIdKj = "riyoNamkj_" + roomIndex2 + "_" + doukouIndex;
                const isRepresent = roomIndex == roomIndex2 && doukouIndex == 0;
                // 代表が外れた同行者は空白に設定
                if (doukou.riyoNo == 1) {
                    doukou.riyoNamkn = "";
                    doukou.riyoNamkj = "";
                    doukou.isRepresent = isRepresent;
                    doukou.saveFlg = false;
                }
                if (isRepresent) {
                    // 代表設定された同行者に代表者名に設定
                    doukou.riyoNo = 1;
                    doukou.riyoNamkn = membershipReserveComf.daihyouNameKana;
                    doukou.riyoNamkj = membershipReserveComf.daihyouName;
                    doukou.isRepresent = isRepresent;
                    doukou.saveFlg = false;
                } else {
                    doukou.riyoNo = ++riyoNo;
                }
                room.doukouList[doukouIndex] = doukou;
                document.getElementById(docIdKn).disabled = isRepresent;
                document.getElementById(docIdKj).disabled = isRepresent;
            });
            inputAccompanyInfo[roomIndex2] = room;
        });
        let newList = [];
        inputAccompanyInfo.forEach(value => {
            newList.push(value);
        });
        setInputAccompanyInfo(newList);
    }

    /**
     * 日付を文字列に変換します。
     * @param {*} date 
     * @returns 
     */
    const getDateToString = (date) => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const dispDate = new Date(date);
        const y = dispDate.getFullYear();
        const m = dispDate.getMonth() + 1;
        const d = dispDate.getDate();
        return `${y}年${m}月${d}日(${youbi[dispDate.getDay()]})`;
    }

    /**
     * 入力内容変更
     * @param {*} roomIndex 
     * @param {*} accompanyIndex 
     * @param {*} type 
     */
    const onChangeInput = (roomIndex, accompanyIndex, type) => {
        let target = document.getElementById(type + "_" + + roomIndex + "_" + accompanyIndex).value;
        inputAccompanyInfo[roomIndex]["doukouList"][accompanyIndex][type] = target;
        inputAccompanyInfo[roomIndex]["doukouList"][accompanyIndex]["customerSeq"] = "";
        let newList = [];
        inputAccompanyInfo.forEach(value => {
            newList.push(value);
        });
        setInputAccompanyInfo(newList);
    }

    /**
     * 入力内容変更
     * @param {*} roomIndex 
     * @param {*} accompanyIndex 
     * @param {*} type 
     */
    const onChangeInputKana = (roomIndex, accompanyIndex, value) => {
        inputAccompanyInfo[roomIndex]["doukouList"][accompanyIndex]["riyoNamkn"] = value;
        inputAccompanyInfo[roomIndex]["doukouList"][accompanyIndex]["customerSeq"] = "";
        let newList = [];
        inputAccompanyInfo.forEach(value => {
            newList.push(value);
        });
        setInputAccompanyInfo(newList);
    }

    /**
     * 
     * @param {*} roomIndex 
     * @param {*} accompanyIndex 
     * @param {*} value 
     */
    const onChangeKana = (roomIndex, accompanyIndex, value) => {
        if (typeof value !== "string") {
            // カナに紐づくをSEQを設定
            inputAccompanyInfo[roomIndex]["doukouList"][accompanyIndex]["customerSeq"] = value.customerSeq;
            inputAccompanyInfo[roomIndex]["doukouList"][accompanyIndex]["riyoNamkj"] = value.riyoNamkj;
            let newList = [];
            inputAccompanyInfo.forEach(row => {
                newList.push(row);
            });
            setInputAccompanyInfo(newList);
        }
    }

    /**
     * 同行者保存フラグの変更イベント
     * @param {int} roomIndex 
     * @param {int} accompanyIndex 
     */
    const onChangeSaveFlg = (roomIndex, accompanyIndex) => {
        let target = document.getElementById(`saveFlg_${roomIndex}_${accompanyIndex}`).checked;
        inputAccompanyInfo[roomIndex]["doukouList"][accompanyIndex]["saveFlg"] = target;
        let newList = [];
        inputAccompanyInfo.forEach(value => {
            newList.push(value);
        });
        setInputAccompanyInfo(newList);
    }

    /**
     * 「戻る」ボタン押下時
     */
    const onClickBack = () => {
        if (membershipReserveComf.pageKbn === "membershipResvComp") {
            history.push("/reserve/hotel/reserveComplete");
        } else if (membershipReserveComf.pageKbn === "membershipResvComf") {
            history.push("/reserve/hotel/hotelBookingConfirmDetail");
        }
    }

    /**
     *「確認画面へ」ボタン押下時
     */
    const onClickCheckInput = () => {
        let rooms = [];
        let errZenkakuKana = false;
        let errOverMaxLength = false;
        let errRequiredSpace = false;
        let errMsg = [];
        let inputNum = 0;
        inputAccompanyInfo.forEach(value => {
            let accompanies = [];
            value.doukouList.forEach(accompany => {
                let accompanyFlg = { errriyoNamkn: false, errriyoNamkj: false };
                if (accompany.riyoNamkj?.length && CommonValidation.Require(accompany.riyoNamkn)) {
                    if (!errZenkakuKana) {
                        errMsg.push(messageConst.ZENKAKU_KANA_ERROR);
                        errZenkakuKana = true;
                    }
                    accompanyFlg.errriyoNamkn = true;
                }
                if (CommonValidation.NameKanaSLC(accompany.riyoNamkn)) {
                    if (!errZenkakuKana) {
                        errMsg.push(messageConst.ZENKAKU_KANA_ERROR);
                        errZenkakuKana = true;
                    }
                    accompanyFlg.errriyoNamkn = true;
                }
                if (CommonValidation.OverMaxLength(accompany.riyoNamkn, 36)) {
                    if (!errOverMaxLength) {
                        errMsg.push(messageConst.MAX_LENGTH_ERROR);
                        errOverMaxLength = true;
                    }
                    accompanyFlg.errriyoNamkn = true;
                }
                if (CommonValidation.OverMaxLength(accompany.riyoNamkj, 36)) {
                    if (!errOverMaxLength) {
                        errMsg.push(messageConst.MAX_LENGTH_ERROR);
                        errOverMaxLength = true;
                    }
                    accompanyFlg.errriyoNamkj = true;
                }
                if (CommonValidation.RequiredSpace(accompany.riyoNamkn)) {
                    if (!errRequiredSpace) {
                        errMsg.push(messageConst.REQUIRE_SPACE_NAME);
                        errRequiredSpace = true;
                    }
                    accompanyFlg.errriyoNamkn = true;
                }
                if (CommonValidation.RequiredSpace(accompany.riyoNamkj)) {
                    if (!errRequiredSpace) {
                        errMsg.push(messageConst.REQUIRE_SPACE_NAME);
                        errRequiredSpace = true;
                    }
                    accompanyFlg.errriyoNamkj = true;
                }
                if (!CommonValidation.Require(accompany.riyoNamkn)) {
                    inputNum++;
                }
                accompanies.push(accompanyFlg);
            })
            rooms.push(accompanies);
        });
        if (inputNum <= 1) {
            errMsg.push(messageConst.INPUT_ACCOMPANY_ERROR);
        }
        if (errMsg.length) {
            setFlgList(rooms);
            setErrorInfo({ errorMessage: errMsg, errorFlg: true });
            window.scroll({ top: 0, behavior: 'smooth' })
        } else {
            setFlgList([]);
            setErrorInfo({ errorMessage: null, errorFlg: false });
            history.push("/reserve/hotel/confirmAccompany");
        }
    }

    const deleteReserveConf = () => {
        store.dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: {} } })
    }

    return (
        <div className={state.displayType === "complete" ? "hiddenItem" : "userInputInnerWrapper"}>
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="同行者情報入力"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            <div className="userInputWrapper">
                <div className={"stayInfo"} style={styles.userInput}>
                    <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                        <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessage} />
                    </div>
                    <Label
                        label={"ご予約情報"}
                        className="titleLabel"
                    />
                    <div className={"reservationContentsWrap"}>
                        <div className="reserveInfoContentBlock">
                            <div className="reserveInfoContent">
                                <Label
                                    label="予約番号"
                                    className="reserveInfoTitleGray"
                                />
                                <Label
                                    label={membershipReserveComf.yoyakuNo}
                                    className="confirmContentLabel"
                                />
                            </div>
                        </div>
                        <div className="reserveInfoContentBlock">
                            <div className="reserveInfoContent">
                                <Label
                                    label="ホテル名"
                                    className="reserveInfoTitleGray"
                                />
                                <Label
                                    label={membershipReserveComf.shisetsuName}
                                    className="confirmContentLabel"
                                />
                            </div>
                        </div>
                        <div className="reserveInfoContentBlock">
                            <div className="reserveInfoContent">
                                <Label
                                    label="チェックイン"
                                    className="reserveInfoTitleGray"
                                />
                                <Label
                                    label={getDateToString(membershipReserveComf.checkInDate)}
                                    className="confirmContentLabel"
                                />
                            </div>
                        </div>
                        <div className="reserveInfoContentBlock">
                            <div className="reserveInfoContent">
                                <Label
                                    label="チェックアウト"
                                    className="reserveInfoTitleGray"
                                />
                                <Label
                                    label={getDateToString(membershipReserveComf.checkOutDate)}
                                    className="confirmContentLabel"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* 同行者情報入力フォーム */}
            {inputAccompanyInfo.length != 0 ? <>
                {inputAccompanyInfo.map((value, roomIndex) =>
                    <div key={value.roomTypeCd + roomIndex}>
                        <div className="userInputWrapper3">
                            <div><Label label={(roomIndex + 1) + "室目"} className="roomIndex" /></div>
                        </div>
                        <div className="representInputWrapper">
                            <div className="userInput2">
                                <div className={"stayInfo"} style={styles.userInput}>
                                    <div className="accompanyWrap">
                                        <Label label="お部屋タイプ" className="popupLabel" />
                                        <Label label={value.rmTypeNam} className="inputContentLabel1" />
                                    </div>
                                    <div className="accompanyWrap">
                                        <Label label="ご利用人数" className="popupLabel" />
                                        <div className="inputContentLabel1">男性：{value.ninzuMale}名　女性：{value.ninzuFemale}名　小学生：{value.ninzuChild}名　幼児：{value.ninzuYoji}名　乳児：{value.ninzuBaby}名</div>
                                    </div>
                                    {/* <Label label="名前（カナ・漢字）" className="popupLabel" /> */}
                                    {value.doukouList.map((accompany, accompanyIndex) =>
                                        <div className="accompanyInputAreaWrap">
                                            <div style={{ display: "flex" }}>
                                                <Label label={(accompanyIndex + 1) + "人目"} className="popupLabel" />
                                                {accompanyIndex === 0 ?
                                                    <RadioButtonForm
                                                        data={[{ value: "represent", checked: accompany.riyoNo == 1, text: "利用代表者" }]}
                                                        id={"representFlg_" + roomIndex}
                                                        name="representFlg"
                                                        labelClassName={"inputRadioLabel"}
                                                        inputClassName={"inputRadioButtonGold"}
                                                        onChange={() => handleRepresentFlg(roomIndex)}
                                                    />
                                                    : null}
                                            </div>
                                            <div className={useMediaFlag ? "accompanyInputAreaMobile" : "accompanyInputArea"}>
                                                <InputText id={`seq_${roomIndex}_${accompanyIndex}`} type="hidden" />
                                                <LabelComboBoxForm
                                                    id={"riyoNamkn_" + roomIndex + "_" + accompanyIndex}
                                                    label="カナ"
                                                    options={douhanSelectList}
                                                    value={accompany.riyoNamkn}
                                                    defaultValue={accompany.riyoNamkn}
                                                    getOptionLabel={(option) => (option && option.riyoNamkn ? option.riyoNamkn : option)}
                                                    className={flgList[roomIndex] && flgList[roomIndex][accompanyIndex] && flgList[roomIndex][accompanyIndex].errriyoNamkn ? "accompanyInputTextErr" : "accompanyInputText "}
                                                    onInputChange={(event, value) => onChangeInputKana(roomIndex, accompanyIndex, value)}
                                                    onChange={(event, value) => onChangeKana(roomIndex, accompanyIndex,  value)}
                                                    labelClassName="accompanyLabel"
                                                    wrapClassName={useMediaFlag ? "accompanyInputTextWrapMobile" : "accompanyInputTextWrap"}
                                                    disabled={accompany.riyoNo == 1}
                                                    maxLength={"35"}
                                                    freeSolo
                                                    disableClearable
                                                    renderOption={(option, state) => 
                                                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%"}}>
                                                          <div>{option.riyoNamkn}<span style={{display: "block"}}>{option.riyoNamkj}</span></div>
                                                        </div>
                                                    }
                                                />
                                                <LabelInputForm
                                                    id={"riyoNamkj_" + roomIndex + "_" + accompanyIndex}
                                                    label="漢字"
                                                    value={accompany.riyoNamkj}
                                                    className={flgList[roomIndex] && flgList[roomIndex][accompanyIndex] && flgList[roomIndex][accompanyIndex].errriyoNamkj ? "accompanyInputTextErr" : "accompanyInputText "}
                                                    onChange={() => onChangeInput(roomIndex, accompanyIndex, "riyoNamkj")}
                                                    labelClassName="accompanyLabel"
                                                    wrapClassName={useMediaFlag ? "accompanyInputTextWrapMobile" : "accompanyInputTextWrap"}
                                                    disabled={accompany.riyoNo == 1}
                                                    maxLength={"35"}
                                                />
                                            </div>
                                            {
                                                accompany.isRepresent ? 
                                                null :
                                                <div className="accompanyInputAreaSaveFlgWrap">
                                                    <CheckboxListBoxGold
                                                        id={`saveFlg_${roomIndex}_${accompanyIndex}`}
                                                        data={[{value: "この同行者を保存する", id: `"true_${roomIndex}_${accompanyIndex}`, checked: accompany.saveFlg}]}
                                                        onChange={() => {onChangeSaveFlg(roomIndex, accompanyIndex)}}
                                                        tabIndex=""
                                                    />
                                                </div>
                                            }
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="btnToReserveConfirmWrapper">
                    <div class={"confirmboxWrap"}>
                        <Button buttonText="戻る" className="btnBack btnSpStyle" onClick={onClickBack} buttonClassName="serachBtnText" />
                        <Button buttonText="確認画面へ" className="btnToConfirm btnSpStyle2" onClick={onClickCheckInput} buttonClassName="serachBtnText" />
                    </div>
                </div></>
                : <Label label="同行者情報が存在しません。" className="noneAccompanyInfoLabel" />}
            <div className="backTopInputUser">
                <Link to={loginType === "MEMBER" ? "/reserve/hotel/search" : "/reserve/hotel/crawlSearch"} style={styles.bottomLink} onClick={() => deleteReserveConf() } >ホテル検索TOPへ戻る</Link>
            </div>
            <div><MembershipFooterContainer className={"reservationResultFooterBase"} /></div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        mealInfoList: state.mealInfoList,
        membershipReserveComf: state.membershipReserveComf,
        resvKaiinken: state.resvKaiinken,
        inputAccompanyInfo: state.inputAccompanyInfo,
        prevScreenInfo: state.prevScreenInfo
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setMealInfoList: (item) => {
            dispatch({ type: "MEAL_INFO_LIST", payload: { mealInfoList: item } })
        },
        setInputAccompanyInfo: (item) => {
            dispatch({ type: "INPUT_ACCOMPANY_INFO", payload: { inputAccompanyInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(MembershipInputAccompanyContainer);

const styles = {
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
}
